import { useTheme, THEME_DOMAIN, COOKIE_THEME_KEY } from '@pancakeswap/hooks'

export { THEME_DOMAIN, COOKIE_THEME_KEY }
export default useTheme
